import stickybits from 'stickybits';

if (window.matchMedia('(max-width: 992px)').matches) {
    /* Mobile */
    stickybits('.c-nav', {
        useStickyClasses: true,
        stickyBitStickyOffset: -70
    });
    stickybits('.c-nav--products', {
        useStickyClasses: true,
        stickyBitStickyOffset: 10
    });
} else {
    /* Desktop */
    stickybits('.c-nav', {
        useStickyClasses: true,
        stickyBitStickyOffset: -93
    });
    stickybits('.c-nav--products', {
        useStickyClasses: true,
        stickyBitStickyOffset: 74
    });
}